import * as React from "react"
import { Link } from "react-router-dom"
import Stack from 'react-bootstrap/Stack';
import {NavigationBar, Layout} from "./layout"
import { Typography } from "@mui/material";
import Table from "react-bootstrap/Table";
import "./layout.css"
// navigation bar covers master's head in the image
// do not show image until it is fixed
const heroImage=<div style={{ display: "grid" }}>
<img
  style={{
    gridArea: "1/1",
    // maxHeight: 600,
  }}
  layout="fullWidth"
  aspectRatio={2 / 1}
  alt=""
  src="/practiceBanner.jpg"
  quality="40"
  formats={["auto", "webp", "avif"]}/>
<div
  style={{
    gridArea: "1/1",
    position: "relative",
    placeItems: "center",
    display: "grid",
  }}
>
</div>
</div>

const Practices = () => (
  <><NavigationBar/>
  {heroImage}
  <Layout>
  <Table style={{tableLayout: "fixed"}}><tbody><tr><td/><td colSpan={7}>
         <Typography variant="h3">
         在國際菩提光修行
      </Typography><br/>
</td><td/></tr>
<tr><td/><td colSpan={7}>
<img src={"/masterPractice.jpg"} width={420} style={{float: "left", margin: "15px"}} />
<Typography variant="body1">
<Link to="/master">永化法師</Link> 在<Link to="/location">國際菩提光的所有道場</Link>訓練出家人和在家人。<br/><br/>
每週六早上9點到10點，國際菩提光提供坐禪練習，之後永化法師在10點到11點講禪修開示。每週日，我們舉行淨土法會，包括念佛名號、唱誦和靜修，法會後有淨土開示。每週日下午從12點半到兩點半，永化法師講解大乘佛教經典。週末兩天的活動都包括免費素食午餐。<Link to="/upcoming-events">詳見具體的週末日程。</Link><br/><br/>
國際菩提光每年舉辦兩次<Link to="/chanqi">長達數月的強化禪修訓練——禪七</Link>，冬季禪七從12月至1月，夏季禪七從5月到6月。禪七給修行人提供了稀有的機會，按照傳統禪宗的訓練時間表進行禪修。傳統禪七的時間表在一天中有15個一小時的禪坐，禪坐中間有20分鐘的行禪和午餐休息。<br/><br/>
我們鼓勵參與者盡量按照日程表來練習。 然而，由於它非常嚴格，大多數初級和中級禪修者發現一開始很難完全跟隨日程表，因此獲得允許增加了休息時間。不過，隨著時間的推移，許多人進步了，能夠完全按照日程坐禪。<br/><br/>
此外，廬山寺的所有駐寺弟子都遵循每日日程表，包括早、晚、午課，還有工作以及個人修行和學習的時間。<br/><br/>
作為廬山寺的修行人，我們一生致力於通過改過來修清淨。 我們願盡心盡力幫助一切眾生，以報答父母和師長的恩德。</Typography></td><td/></tr>
<tr><td/><td colSpan={7}>
  <br/><br/>
<Typography variant="h3">禪和淨土佛教</Typography>
<Typography variant="body1">
永化法師教授傳統大乘佛教的義理，絕大部分義理是他從北加州萬佛城的創始人宣化上人那裡學來的。 宣化上人於二十世紀60年代將中國佛教帶到美國。 中國大乘佛法非常博大精深，包含了很多在這個國家還不容易接觸到的義理和教導。
<img src={"/practiceImg.jpg"} style={{float: "right", margin: "15px"}} />
中國大乘佛教融合了佛教的禪、淨、密、律、教等五宗。永化法師吸納了所有五宗。不過，永化法師主要專注於禪淨雙修，以便更好地服務這個時代更大範圍、不同根器的眾生。 <br/><br/>
禪宗專注於此生證悟。淨土宗則教修行者如何往生阿彌陀佛西方極樂淨土，往生後能夠在接下來的一生中證悟。通過禪淨雙修，我們願今生開悟； 不過，我們也知道這是一個非常難以達到的目標，因此我們用淨土法作為後備計劃。事實上，淨土法如同一張保險單：若我們此生未能證悟，能令我們在下一生中繼續進步。 <br/><br/>
為了開啟我們的智慧，禪宗教我們提高定力的方法，定力在佛教中稱為三摩地。沒有定力，不可能發展出洞察力或出世間的智慧。禪宗通過坐禪來培養我們的定力，這是佛陀本人證悟的修行方式。 <br/><br/>
<img src={"/amituofo.png"} style={{float: "left", margin: "15px"}} />
如果我們成功提高了定力，不僅會在獲得洞察力的道路上取得進步，還能改善我們的健康，減輕壓力，增加耐力和精神力量。而且，隨著我們定力的加深，修淨土法的效果也會大大提高。因此，禪修技術對所有淨土修行者都有很大幫助。 <br/><br/>
此外，大乘佛法非常豐富，包括很多別的修行方式，例如：禮懺、誦經、懺悔法會、念咒、學係佛經、持戒、供養、助持弘法和修行等。事實上，根據佛經，有八萬四千種不同的修行，稱為法門，我們可以藉鑒。 <br/><br/>
永化法師提供個性化指導，幫助每個人找到最適合他們當下修行的方法。永化法師在講座中用了大量的時間來回答問題。這使他的教學能夠契合個體學生的需要。 <br/><br/>
過去八年中，永化法師所教的許多學生達到了高層次的三摩地，健康和人際關係都有了顯著改善。 <br/><br/>
</Typography></td><td/></tr></tbody></Table>
  </Layout>
  </>
)

export default Practices
